// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9be73832","239":"bdcd3cfa","453":"1aa6ece4","455":"4b9cd934"}[chunkId] + ".chunk.js";
};